import React, { FC } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import CloseIcon from '@material-ui/icons/Close';

import {
  withSegments,
  IWithSegments,
  withClientLocations,
  IWithClientLocations,
  withClientDepartments,
  IWithClientDepartments,
} from 'providers/queries';
import { GroupFragment, SegmentStatus } from 'api';

interface IProps {
  selectedGroups?: GroupFragment[];
  flattenedFilter: string[];
  onRemove: (id: string) => void;
}

interface IPropsEnhanced
  extends IProps,
    IWithSegments,
    IWithClientLocations,
    IWithClientDepartments {}

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(2),
    '& > div': {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
}));

const enhancers = compose<IPropsEnhanced, IProps>(
  withSegments(SegmentStatus.Active),
  withClientLocations,
  withClientDepartments,
);

const FilterChips: FC<IPropsEnhanced> = ({
  selectedGroups,
  flattenedFilter,
  onRemove,
  segments,
  clientDepartments,
  clientLocations,
}) => {
  const classes = useStyles();

  const { client_departments } = clientDepartments;
  const { client_locations } = clientLocations;
  // @ts-ignore
  const masterList = segments.concat(selectedGroups, client_departments, client_locations);

  return (
    <div className={classes.container}>
      {flattenedFilter.map(id => {
        const resource = masterList.find(item => item.id === id);

        return (
          <Chip
            key={id}
            variant="outlined"
            label={resource?.title}
            onDelete={() => onRemove(id)}
            deleteIcon={<CloseIcon fontSize="small" />}
          />
        );
      })}
    </div>
  );
};

FilterChips.defaultProps = {
  selectedGroups: [],
};

export default enhancers(FilterChips);
